export default __webpack_public_path__ + "static/media/Salient Features_USHPP_1.0cfa2f5c.jpg";